



































































































































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import CommonButton from '@/components/common/CommonButton.vue';
import { ProjectCustomAttributeType, TaskAttributeValueOption } from '@/@types/Project';
import { ColorCd } from '@/@types/constant';
import { vxm } from '@/store';

@Component({
  components: {
    CommonButton,
  },
})
export default class TaskAttributeColumn extends Vue {
  @Prop({ required: true })
  private attribute!: ProjectCustomAttributeType;

  private randomInt: number[] = [];

  private isDefault(name: string) {
    return name === 'カテゴリー' || name === '優先度' || name === 'ステータス' ? true : false;
  }

  /** 重複無し乱数生成 */
  private generateIntRandom() {
    let identifer: number;
    while(true) {
      const tmp = Math.floor( Math.random() * (10000000));
      if (!this.randomInt.includes(tmp)) {
        this.randomInt.push(tmp);
        identifer = tmp;
        break;
      }
    }
    return identifer;
  }

  private addTaskAttributeValueOption(attribute: ProjectCustomAttributeType) {
    const newOption: TaskAttributeValueOption = {
      taskAttributeValueOptionId: 0,// 仮のID。デベロッパーツールでv-forのkeyが重複してると怒られる。
      projectId: 0,
      attributeCd: attribute.attributeCd,
      value: null,
      colorCd: ColorCd.AliceBlue,
      attributeItemContent: null,
      identifer: this.generateIntRandom(),// このメソッドで追加されたTaskAttributeValueOptionだけには識別子を設けて削除する際に識別子を見て削除する。
    }
    attribute.attributeOptions.push(newOption);
  }

  private async createOption(attributeOption: TaskAttributeValueOption) {
    const currentProjectId = 1; // TODO: authStoreからcurrentProjectIdが取れるようになったら修正
    await vxm.theoryApi.projectsStore.createTaskAttributeValueOption({
      projectId: currentProjectId,
      attributeCd: attributeOption.attributeCd,
      value: attributeOption.value,
      colorCd: attributeOption.colorCd,
      attributeItemContent: attributeOption.attributeItemContent,
    })
    const createdOption = vxm.theoryApi.projectsStore.getCreatedTaskAttributeValueOption;
    if (createdOption) {
      const index = this.attribute.attributeOptions.findIndex((v) => v.identifer === attributeOption.identifer);
      this.attribute.attributeOptions[index] = createdOption;
    }
  }

  private handleDeleteOption(attributeOption: TaskAttributeValueOption) {
    if (attributeOption.taskAttributeValueOptionId) {
      this.deleteOption(attributeOption.taskAttributeValueOptionId);
    } else {
      this.attribute.attributeOptions = this.attribute.attributeOptions.filter((v) => v.identifer !== attributeOption.identifer);
    }
  }

  @Emit('delete-option')
  private deleteOption(taskAttributeValueOptionId: number) {
    this.attribute.attributeOptions = this.attribute.attributeOptions.filter((v) => v.taskAttributeValueOptionId !== taskAttributeValueOptionId);
    return taskAttributeValueOptionId;
  }

}
